import { gql } from "@apollo/client";

export const BUSINESS_FAX_FIELDS = `
  id
  businessId
  direction
  status
  toNumber
  fromNumber
  fileUrl
  fileName
  pages
  subject
  errorMessage
  externalFaxId
  provider
  metadata
  receivedAt
  sentAt
  uploadedByStaffId
  createdAt
  updatedAt
`;

export const GET_BUSINESS_FAXES = gql`
  query GetBusinessFaxes($businessId: ID!, $limit: Int) {
    getBusinessFaxes(businessId: $businessId, limit: $limit) {
      ${BUSINESS_FAX_FIELDS}
    }
  }
`;

export const GET_BUSINESS_FAX_USAGE = gql`
  query GetBusinessFaxUsage($businessId: ID!) {
    getBusinessFaxUsage(businessId: $businessId) {
      businessId
      monthlyLimit
      used
      remaining
      isLimited
    }
  }
`;

